import BaseComponent from '../BaseComponent';
import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';

const NAME = 'CourtAvaibilityPagination';

const SELECTOR_PREVIOUS_BUTTON = '.js-court-pagination-previous';
const SELECTOR_NEXT_BUTTON = '.js-court-pagination-next';
const SELECTOR_COURT_NAME = '.court-name-mobile';
const SELECTOR_COURT_TYPE = '.court-type-mobile';
const SELECTOR_COURT_SURFACE = '.court-surface-mobile';
const HIDE_SELECTOR = 'pagination-button-hide';

const SELECTOR_SPAN = 'span';

const CLICK_EVENT = 'click';

class CourtAvaibilityPagination extends BaseComponent {

	constructor(element) {
		super(element);
		this._previousCallbacks = [];
		this._nextCallbacks = [];
		this.init();
	}

	static get NAME() {
		return NAME;
	}

	set paginationData(data) {
		this._paginationData = data;
		this.renderButton(this._paginationData);
	}

	get paginationData() {
		return this._paginationData;
	}

	init() {
		if(!this._element){
			return;
		}

		this.courtPaginationText = SelectorEngine.findOne(SELECTOR_SPAN, this._element);
		
		this.courtMobileName = SelectorEngine.findOne(SELECTOR_COURT_NAME, this._element);
		this.courtMobileType = SelectorEngine.findOne(SELECTOR_COURT_TYPE, this._element);
		this.courtMobileSurface = SelectorEngine.findOne(SELECTOR_COURT_SURFACE, this._element);

		this.previousButton = SelectorEngine.findOne(SELECTOR_PREVIOUS_BUTTON, this._element);
		this.nextButton = SelectorEngine.findOne(SELECTOR_NEXT_BUTTON, this._element);

		EventHandler.on(this.previousButton, CLICK_EVENT, this.onPreviousClickHandler.bind(this));
		EventHandler.on(this.nextButton, CLICK_EVENT, this.onNextClickHandler.bind(this));
	}

	onPrevious(callback){
		this._previousCallbacks.push(callback);
	}

	onNext(callback){
		this._nextCallbacks.push(callback);
	}

	onPreviousClickHandler() {
		for (const callback of this._previousCallbacks) {
			callback();
		}
	}

	onNextClickHandler() {
		for (const callback of this._nextCallbacks) {
			callback();
		}
	}

	renderButton(data){
		let lastIndex = data.currentIndex + data.pagination;
		let previousHide = false;
		if(lastIndex > (data.courtData.length - 1)){
			lastIndex = data.courtData.length;
			previousHide = true;
		}

		if(data.currentIndex === 0 && previousHide){
			this.previousButton.classList.add(HIDE_SELECTOR);
			this.nextButton.classList.add(HIDE_SELECTOR);
		}else{
			this.previousButton.classList.remove(HIDE_SELECTOR);
			this.nextButton.classList.remove(HIDE_SELECTOR);
		}

		if(data.currentIndex === 0){
			this.previousButton.classList.add(HIDE_SELECTOR);
		}else{
			this.previousButton.classList.remove(HIDE_SELECTOR);
		}
		if(previousHide){
			this.nextButton.classList.add(HIDE_SELECTOR);
		}else{
			this.nextButton.classList.remove(HIDE_SELECTOR);
		}

		if(this.courtPaginationText){
			this.courtPaginationText.innerHTML = (data.currentIndex + 1) === lastIndex ? 
				`Court ${data.currentIndex + 1}`:`Courts ${data.currentIndex + 1} - ${lastIndex}`;
		}

		if(this.courtMobileName) this.courtMobileName.innerHTML = `${data.courtData[data.currentIndex].name}`;
		if(this.courtMobileType) this.courtMobileType.innerHTML = `${data.courtData[data.currentIndex].type}`;
		if(this.courtMobileSurface) this.courtMobileSurface.innerHTML = `${data.courtData[data.currentIndex].surface} court`;
	}
}

export default CourtAvaibilityPagination;
